import React, { useState } from 'react'
import imageUrlTransformation from "../../global/imageUrlTransformation";
import { isMobile, isDesktop, isIpad } from "../../global/ScreenSizeHelper";
import Loader from "../../composed/Loader/Loader";
import fallBackImage from "../../global/assets/svg/ImageError.svg";



const Ingredients = (props) => {
    const { productDetail } = props
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);


    const generateWidth = () => {

        const widthSize = 600

        if (isMobile) {
            return 350
        }

        if (isIpad) {
            return 450
        }

        if (isDesktop) {
            return 600
        }

        return widthSize
    }


    const onImageLoad = () => {
        setImageLoaded(true);
    };

    const onImageError = () => {
        setImageError(true);
        setImageLoaded(true);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {!isMobile && <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: "18px",
                fontFamily: 'roboto medium',
                color: '#00315C',
                border: '1px solid  #95ED87',
                width: '200px',
                height: '35px',
                marginTop: '10px',
                borderRadius: '5px',
                backgroundColor: ` #95ED87`
            }}> Fresh Ingredients</div>}


            <div style={{ width: '100%' }}>
                {productDetail?.ingredients_image && <img
                    width={imageLoaded ? 'auto' : 0}
                    src={
                        imageError
                            ? fallBackImage
                            : imageUrlTransformation({
                                imageUrl: productDetail?.ingredients_image,
                                fillType: "fill",
                                width: generateWidth()
                            })
                    }
                    onLoad={() => onImageLoad()}
                    onError={() => onImageError()}
                    onClick={() => {
                        // console.log("image clicked pdp desktop");
                    }} alt=""></img>}

                {!imageLoaded && (
                    <Loader color="black" width="40px" height="40px" />
                )}
            </div>


        </div>


    )
}

export default Ingredients